const ignorableWindowErrorMessages = new Set([
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
  "The user agent does not support public key credentials."
]);

/**
 * Browserhinweise, die über window.onerror oder unhandledrejection gemeldet
 * werden, obwohl kein Anwendungsfehler vorliegt. Die Liste bleibt absichtlich
 * eng gefasst.
 */
export function isIgnorableWindowError(message: unknown): boolean {
  const text = String(message ?? "").trim();
  if (ignorableWindowErrorMessages.has(text)) return true;
  return text.includes("does not support public key credentials");
}
